var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.84601 12.6259L7.14176 10.5216L2.44814 13.6781L6.25453 16.8346L6.55027 14.7302H9.73458C11.4255 14.7294 13.1403 14.0641 14.5026 12.8805C15.8648 11.6968 16.763 10.0916 17 8.41728H14.875C14.7182 9.53275 14.1207 10.6026 13.2137 11.3917C12.3067 12.1809 11.1644 12.6248 10.0378 12.6259H6.84601ZM10.4497 2.10432H7.26542C5.57451 2.10515 3.85967 2.77044 2.49745 3.95407C1.13523 5.13771 0.237001 6.74294 0 8.41728H2.125C2.28177 7.30181 2.87931 6.23196 3.78633 5.44281C4.69335 4.65366 5.83565 4.20975 6.96224 4.20864H10.154L9.85824 6.31296L14.5519 3.15648L10.7455 0L10.4497 2.10432Z",
    fill: "#ECEAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeat);
export default __webpack_public_path__ + "static/media/repeat.68deff83901080eae94815955146d7c8.svg";
export { ForwardRef as ReactComponent };